

export default class AvatarCreator{

    constructor(canvas){
        this.canvas = canvas;
        this.ctx = this.canvas.getContext('2d');
        this.width  = this.canvas.width;
        this.height = this.canvas.height;
        this.paddingX = 5;
        this.paddingY = 20;


        this.string = '';


        this.bgColors = ['#000000', '#FFFFFF'];
        this.bgImages = [];
        this.fgColors = [];

    }

    render(string){


        this.ctx.clearRect(0,0,this.width,this.height);

        if(string.length<3) return;


        this.string = string.split('').reverse().join('')
        const bg = this.string[0];
        const fg = this.string[1];


        this.renderBg();

        let   i  = 0;
        const params = 4;

        //console.log(this.string, this.string.length)

        while(i< (this.string.length - params)){
            //console.log(i);
            let pt = this.string.substr(i, params);
            if(pt.length<params) pt += this.string.substr(0, params - pt.length);
            this.renderPoint(pt);
            i+=1;
        }

    }

    renderBg(){
        let c = this.bgColors[this.string.length % this.bgColors.length];
        this.ctx.fillStyle = c;
        this.ctx.fillRect(0,0, this.width, this.height);

    }

    renderFg(str){

    }

    renderPoint(str){
        const x = this.posFromChar(str[0], this.width, this.paddingX);
        const y = this.posFromChar(str[1], this.height, this.paddingY);
        const s = this.pointSizeFromChar(str[3]);

        this.ctx.shadowColor = this.colorFromChar(str[2], 100);
        this.ctx.fillStyle   =  this.colorFromChar(str[2], this.charToPer(str[3]));
        this.ctx.shadowBlur  = 30;
        this.ctx.beginPath();
        this.ctx.arc(x, y, s, 0, Math.PI*2);
        this.ctx.closePath();
        this.ctx.fill();

    }

    charToPer(char){
        let ccn = parseInt(char,16);
        return parseInt(100 / 15 * ccn);
    }

    posFromChar(char, max, padding){
        let pad = max / 100 * padding;
        let pos = pad + this.charToPer(char) / 100 * (max - (2*pad)) ;
        return pos;
    }

    colorFromChar(char, alpha){
        let n = this.charToPer(char) % 100;
        let h = (n * 3.6) + 220 ;
        let s = 50 + (n*0.5);
        let l = 20 + (n*0.3);
        let a = parseFloat(alpha/160)  //(10 + (n*0.4)) / 100;
        //if(!alpha)console.log('Alpha: '+a);
        return 'hsla(' + h + ',' + s + '%,' + l + '%,' + a + ')';
    }

    pointSizeFromChar(char){
        let max = Math.min(this.width, this.height) / 2;
        return parseInt(this.charToPer(char) / 100 * max);
    }



}




// WEBPACK FOOTER //
// ./src/services/AvatarCreator.js